import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom'; 
import { checkAuth } from '../api/auth';
import { Skeleton, Stack } from '@mui/material';

const PrivateRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const verifyToken = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        setIsAuthenticated(false);
        setIsLoading(false);
        return;
      }

      try {
        await checkAuth();
        setIsAuthenticated(true);
      } catch (error) {
        localStorage.removeItem('token');
        setIsAuthenticated(false);
      } finally {
        setIsLoading(false);
      }
    };

    verifyToken();
  }, []);

  if (isLoading) {
    return (
      <Stack spacing={2} sx={{ p: 3 }}>
        <Skeleton variant="rectangular" width="100%" height={120} />
        <Skeleton variant="text" width="60%" height={40} />
        <Skeleton variant="rounded" width="80%" height={300} />
      </Stack>
    );
  }

  return isAuthenticated ? children : <Navigate to="/authentication/sign-in" replace />;
};

export default PrivateRoute;